import { AutocompleteInput, useTranslate } from "react-admin";
import { Box } from "@mui/material";
import { memo, useCallback, useMemo } from "react";

export const RaAutocompleteInput = memo(
    ({ label, field, optionText, inputText: inputTextProp, filterToQuery: filterToQueryProp, ...props }) => {
        const translate = useTranslate();

        const inputText = useCallback(
            (choice) => {
                if (typeof inputTextProp === "function") {
                    return inputTextProp(choice);
                }

                const value = choice?.[field];
                if (typeof value === "string") {
                    return value;
                }

                if (typeof value === "number") {
                    return `${value}`;
                }

                return "";
            },
            [field, inputTextProp]
        );

        const OptionText = useCallback(
            (option) => {
                return (
                    <Box sx={{ width: "100%", whiteSpace: "pre-line" }} title={option[field]}>
                        {optionText ? optionText(option) : option[field]}
                    </Box>
                );
            },
            [field, optionText]
        );

        const filterToQuery = useMemo(
            () =>
                typeof filterToQueryProp === "function"
                    ? filterToQueryProp
                    : (searchText) => ({ [field]: searchText }),
            [field, filterToQueryProp]
        );

        const translatedLabel = useMemo(() => translate(label), [translate, label]);
        const noOptionsText = useMemo(() => translate("equip.noOptions"), [translate]);

        return (
            <AutocompleteInput
                {...props}
                label={label}
                title={translatedLabel}
                optionText={OptionText}
                inputText={inputText}
                filterToQuery={filterToQuery}
                noOptionsText={noOptionsText}
            />
        );
    }
);
